import React, { FC, useEffect, useRef } from 'react';

import { useIntersectionObserver } from '@crehana/react-hooks';
import { useAmplitude } from '@crehana/analytics';

export interface TrackUserScrollProps {
  amplitudePageName: string;
  sectionName: string;
}

export const TrackUserScroll: FC<TrackUserScrollProps> = ({
  amplitudePageName,
  sectionName,
}) => {
  const ref = useRef(null);
  const observer = useIntersectionObserver(ref, { freezeOnceVisible: true });
  const { logEvent } = useAmplitude();

  useEffect(() => {
    if (observer?.isIntersecting) {
      logEvent({
        event: 'User Scrolled',
        data: {
          'Source Detail': amplitudePageName,
          Section: sectionName,
        },
      });
    }
  }, [observer?.isIntersecting]);

  return <div ref={ref} />;
};

export default TrackUserScroll;
